import type { StoreAccessScope, UserRole } from "@prisma/client"

export type AuthStoreAccess = {
  storeId: string
  storeName: string
  scope: StoreAccessScope
}

const PUBLIC_PATH_PREFIXES = ["/login", "/signup", "/unauthorized", "/invite", "/terms", "/privacy", "/tokushoho"]
const MANAGEMENT_PATH_PREFIXES = ["/shifts", "/staff", "/settings", "/demand-forecast", "/studio", "/flow", "/platform", "/chat"]

export function isPublicPath(pathname: string) {
  return PUBLIC_PATH_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`))
}

export function isManagementPath(pathname: string) {
  return MANAGEMENT_PATH_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`))
}

export function isManagementRole(role?: UserRole | null) {
  return role === "ADMIN" || role === "SV" || role === "MANAGER"
}

export function canAccessPath(role: UserRole | undefined, pathname: string) {
  if (!role) return false

  if (role === "STAFF") {
    return !isManagementPath(pathname)
  }

  return true
}

export function getDefaultPathForRole(role?: UserRole | null) {
  if (role === "STAFF") {
    return "/staff-portal"
  }

  // 管理側の「ホーム」はフローボード（/）。以前は /shifts（現・AI一括作成への
  // リダイレクト）を返しており、サイドバーの「ホーム」(/) と行き先が食い違っていた。
  return "/"
}

export function getRoleLabel(role?: UserRole | null) {
  switch (role) {
    case "ADMIN":
      return "管理者"
    case "SV":
      return "SV"
    case "MANAGER":
      return "店長"
    case "STAFF":
      return "スタッフ"
    default:
      return "未設定"
  }
}
